export enum BillingType {
    Central = 1,
    Local = 2,
}

export const BillingTypes = [
    { Id: BillingType.Central, TextId: 'billing.central' },
    { Id: BillingType.Local, TextId: 'billing.local' },
];
